<app-reports
  title="User Activities Audit Reports"
  [filtersForm]="filtersForm"
  [forceReportDetailsDisplay]="true"
  [validateForm]="validateForm"
  [reportsUrl]="reportsUrl"
  [reportsCountUrl]="reportsCountUrl">

  <ng-template appNewReportOptionsTemplate let-filtersForm="filtersForm">
    <ng-container [formGroup]="filtersForm">

      <app-report-date-range-option label="Created Date" formControlName="createdDate" />

      <app-report-users-option label="Users" formControlName="userIds" />

    </ng-container>
  </ng-template>

  <ng-template appReportDetailsTemplate let-report="report">

    <app-report-applied-date-range-option
      [options]="report.filters"
      name="createdDate"
      label="User Activity Date" />

    <app-report-applied-users-option
      [options]="report.filters"
      [optionAssociations]="report.filterAssociations"
      name="userIds"
      label="Users" />

  </ng-template>

</app-reports>
